class Info {
    constructor(id, name, emailaddress, message, emailaddressRecipient, dateLastAlive, activeUser, disclosed) {
        this.id = id;
        this.name = name;
        this.emailaddress = emailaddress;
        this.message = message;
        this.emailaddressRecipient = emailaddressRecipient;
        this.dateLastAlive = dateLastAlive;
        this.activeUser = activeUser
        this.disclosed = disclosed;
    }
}

export default Info;